import * as React from "react";
import { QuestionCollectionProps } from "@teamprevent/common/questionnaires/QuestionnaireSectionProps";
import { QuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";
import { MultiButtonQuestion } from "@teamprevent/common/questionnaires/components/questions/MultiButtonQuestion";
import { getAnswerToQuestionWithId } from "@teamprevent/common/questionnaires/getAnswerToQuestionWithId";
import { values } from "lodash";
import { TextQuestion } from "@teamprevent/common/questionnaires/components/questions/TextQuestion";

interface Props extends QuestionCollectionProps {
    questionConfigs: [QuestionConfig, QuestionConfig, QuestionConfig, QuestionConfig];
}

export const CurrentlySufferingAndFollowUpQuestions = (props: Props) => {
    return (
        <>
            <MultiButtonQuestion questionConfig={props.questionConfigs[0]} readonly={props.readonly} />
            {getAnswerToQuestionWithId(values(props.questions || {}), props.questionConfigs[0].id) === MultiButtonQuestion.YesOption &&
            <>
                <MultiButtonQuestion questionConfig={props.questionConfigs[1]} readonly={props.readonly} />
                <MultiButtonQuestion questionConfig={props.questionConfigs[2]} readonly={props.readonly} />
                <TextQuestion questionConfig={props.questionConfigs[3]} readonly={props.readonly} />
            </>}
        </>
    );
};
